import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "../../Service/ApiService";
import Header from "../common/Header";
import formatCurrency from "../common/CurrencyFormatter";
import { Space, Table } from "antd";
import { EditTwoTone } from "@ant-design/icons";

const ManageRoomPage = () => {
  const [rooms, setRooms] = useState([]);
  const [hotels, setHotels] = useState([]);
  const [selectedHotel, setSelectedHotel] = useState();
  const navigate = useNavigate();

  const columns = [
    {
      title: "No.",
      dataIndex: "id",
      key: "id",
      render: (_, _record, idx) => {
        return idx + 1;
      },
    },
    {
      title: "Photo",
      dataIndex: "roomPhotoUrl",
      key: "roomPhotoUrl",
      render: (_, record) => {
        return (
          <img
            src={record.roomPhotoUrl}
            alt={`room ${record.roomName}`}
            style={{ width: "50px", height: "50px", objectFit: "contain" }}
          />
        );
      },
    },
    {
      title: "Name",
      dataIndex: "roomName",
      key: "name",
    },
    {
      title: "Hotel",
      dataIndex: "hotel",
      key: "hotel",
      render: (_, record) => {
        if (record.hotel) {
          return record.hotel.name;
        }
        return "";
      },
    },
    {
      title: "Room Type",
      dataIndex: "roomType",
      key: "roomType",
    },
    {
      title: "Cost per Night",
      dataIndex: "roomPrice",
      key: "roomPrice",
      render: (_, record) => {
        return formatCurrency(record.roomPrice);
      },
    },
    {
      title: "Max Number of Persons",
      dataIndex: "maxPersons",
      key: "maxPersons",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <EditTwoTone
            twoToneColor="#0000ff"
            style={{ cursor: "pointer", fontSize: "16pt" }}
            onClick={() => navigate(`/admin/edit-room/${record.id}`)}
          />
        </Space>
      ),
    },
  ];

  useEffect(() => {
    const fetchRooms = async () => {
      const response = await ApiService.getAllAdminRooms();
      setRooms(response);
    };

    const fetchHotels = async () => {
      const hotels = await ApiService.fetchHotels();
      setHotels(hotels);
    };

    fetchHotels();
    fetchRooms();
  }, []);

  useEffect(() => {
    const fetchHotelRooms = async (hotel) => {
      if (hotel != null) {
        let rooms;
        if (hotel === "all") {
          rooms = await ApiService.getAllRooms(0);
          setRooms(rooms);
        } else {
          rooms = await ApiService.getAllRooms(hotel);
          setRooms(rooms);
        }
      }
    };
    fetchHotelRooms(selectedHotel);
  }, [selectedHotel]);

  const handleHotelChange = (e) => {
    setSelectedHotel(e.target.value);
  };

  return (
    <div className="default-container">
      <Header title={"Manage Rooms"} />
      <div
        className="all-room-filter-div"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div className="filter-select-div">
          <label>Select Hotel:</label>
          <select value={selectedHotel} onChange={handleHotelChange}>
            <option value="all">All</option>
            {hotels.map((hotel) => (
              <option key={hotel.id} value={hotel.id}>
                {" "}
                {hotel.name}{" "}
              </option>
            ))}
          </select>
          <button
            className="add-room-button"
            onClick={() => navigate("/admin/add-room")}
          >
            {" "}
            Add Room{" "}
          </button>
        </div>
      </div>

      <Table
        dataSource={rooms}
        columns={columns}
        rowKey={"id"}
        pagination={{
          position: ["bottomLeft"],
        }}
      />
    </div>
  );
};

export default ManageRoomPage;
